type Props = {
  total: number;
  current: number; // 0-indexed: 0 means "no question yet"
};

/**
 * Quiet horizontal cadence indicator. Visually like beads on a string.
 * Filled = answered. Larger filled = current. Hollow = pending.
 */
export function ProgressDots({ total, current }: Props) {
  return (
    <div
      className="flex items-center gap-1.5"
      aria-label={`Question ${Math.max(1, current)} of ${total}`}
      role="status"
    >
      {Array.from({ length: total }).map((_, i) => {
        const isCurrent = i === current;
        const isAnswered = i < current;
        return (
          <span
            key={i}
            aria-hidden="true"
            className={[
              "rounded-full transition-all duration-500",
              isCurrent
                ? "w-2 h-2 bg-accent-600"
                : isAnswered
                  ? "w-1.5 h-1.5 bg-ink-700/80"
                  : "w-1 h-1 bg-ink-300/40",
            ].join(" ")}
          />
        );
      })}
    </div>
  );
}
